import React, { FC } from 'react';
import { TMediaCarouselArrowProps } from './types/carouselArrow.types';
import Icon from '../../../icon';
import { iconSize } from '../../../../../constants/icon.constants';

const MediaCarouselArrow: FC<TMediaCarouselArrowProps> = ({ direction, onClick, customClass = '' }) => {
  const icon = ('arrow-chevron-' + (direction === 'previous' ? 'left' : 'right')) as 'arrow-chevron-left' | 'arrow-chevron-right';
  return (
    <button
      className={'media-carousel-arrows media-carousel-arrows--' + direction + ' ' + customClass}
      aria-label={direction + 'slide / item'}
      onClick={onClick}
    >
      <Icon iconName={icon} size={iconSize['lg']} />
    </button>
  );
};

export default MediaCarouselArrow;
